<template>
  <section class="pdf-add-wrapper">
    <b-row class="pdf-add-row" style="margin-bottom: 0; padding-bottom: 0">
      <!-- Col: Left (Bill Detail Container) -->
      <b-col class="pdf-add" cols="12" style="margin-bottom: 0; padding-bottom: 0">
        <b-card no-body class="pdf-preview-card" style="">
          <!-- Header -->
          <div class="pdf_header pdf-padding pt-2" style="margin-bottom: 0; padding-bottom: 0">
            <div class="logo">
              <img class="d-block mx-auto" :src="info.logo_url" />
              <h2 class="mx-auto d-table mt-1">供應商帳單明細</h2>
            </div>

            <div class="license color0">
              <div class="license-content" v-html="info.company_info"></div>
            </div>

            <!-- PDF Form - 供應商帳單資料 -->
            <div class="pdf-form">
              <b-row class="form-item">
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="text-right title">供應商名稱：</b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value">
                        {{ pdfData.supplier ? (pdfData.supplier.name_cn || pdfData.supplier.name) : '' }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="text-right title">帳單編號：</b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value pdf-number colorRed">
                        {{ pdfData.bill_number || pdfData.id }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="form-item">
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="text-right title">帳單日期：</b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value">
                        {{ pdfData.bill_date ? formatDate(pdfData.bill_date) : '-' }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="text-right title">帳單總金額：</b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value text-primary font-weight-bold">
                        HK${{ formatMoney(pdfData.bill_total_amount || 0) }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="form-item">
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="title">支出類型：</b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value">
                        {{ pdfData.is_daily_expense ? '日常開支' : '成本開支' }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="text-right title">埋數狀態：</b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value">
                        <span :class="pdfData.is_approved ? 'text-success' : 'text-warning'">
                          {{ pdfData.is_approved ? '已埋數' : '未埋數' }}
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="form-item" v-if="pdfData.approve_user">
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="text-right title">埋數人員：</b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value">
                        {{ pdfData.approve_user ? pdfData.approve_user.name_cn : '-' }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <!-- 發票項目明細 / 項目明細 -->
          <div class="pdf-padding form-item-section" style="padding-top: 10px; padding-bottom: 0; margin-bottom: 0">
            <div class="pdf-section-title">
              <h4 v-if="pdfData.is_daily_expense">項目明細</h4>
              <h4 v-else>發票項目明細</h4>
            </div>
            <div class="pdf-table bill-items">
              <div class="d-flex table-header">
                <div class="thead-label" v-if="pdfData.is_daily_expense">日常開支日期</div>
                <div class="thead-label" v-else>發票編號</div>
                <div class="thead-label">帳單備註</div>
                <div class="thead-label">金額</div>
              </div>

              <div v-if="pdfData.items && pdfData.items.length > 0">
                <div
                  v-for="(item, index) in pdfData.items"
                  :key="index"
                  class="d-flex pdf-item"
                >
                  <div class="pdf-item-text-wrapper text-center">
                    <span class="pdf-item-text colorRed" v-if="pdfData.is_daily_expense">
                      {{ item.daily_expense_date ? formatDate(item.daily_expense_date) : '- -' }}
                    </span>
                    <span class="pdf-item-text colorRed" v-else>
                      {{ item.invoice ? item.invoice.invoice_number : '- -' }}
                    </span>
                  </div>
                  <div class="pdf-item-text-wrapper text-center">
                    <span class="pdf-item-text">{{ item.title ? item.title == 'null' ? '- - ' : item.title : '- -' }}</span>
                  </div>
                  <div class="pdf-item-text-wrapper text-right">
                    <span class="pdf-item-text text-success font-weight-bold">
                      HK${{ formatMoney(item.amount || 0) }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="text-center text-muted py-4">
                <p class="mb-0">此帳單沒有詳細項目資訊</p>
              </div>
            </div>
          </div>

          <!-- 付款資訊 -->
          <div class="pdf-padding form-item-section" style="padding-top: 0; padding-bottom: 0; margin-bottom: 0">
         
            <!-- 付款憑證明細 -->
            <div v-if="hasPaymentProofs()" class="pdf-form" style="min-height: 100px; margin-bottom: 20px;">
              <div class="pdf-section-title mb-2">
                <h5>付款憑證明細</h5>
              </div>
              <div class="pdf-table payment-proofs">
                <div class="d-flex table-header">
                  <div class="thead-label" style="width: 20%;">憑證編號</div>
                  <div class="thead-label" style="width: 15%;">付款日期</div>
                  <div class="thead-label" style="width: 20%;">付款方式</div>
                  <div class="thead-label" style="width: 15%;">付款金額</div>
                  <div class="thead-label" style="width: 30%;">憑證檔案</div>
                </div>

                <div v-if="pdfData.payment_proofs && pdfData.payment_proofs.length > 0">
                  <div
                    v-for="(proof, index) in pdfData.payment_proofs"
                    :key="index"
                    class="d-flex pdf-item"
                  >
                    <div class="pdf-item-text-wrapper text-center" style="width: 20%;">
                      <span class="pdf-item-text colorRed">
                        {{ proof.payment_proof_number || '- -' }}
                      </span>
                    </div>
                    <div class="pdf-item-text-wrapper text-center" style="width: 15%;">
                      <span class="pdf-item-text">
                        {{ formatDate(proof.payment_date) || '- -' }}
                      </span>
                    </div>
                    <div class="pdf-item-text-wrapper text-center" style="width: 20%;">
                      <span class="pdf-item-text">
                        {{ getPaymentMethodNameForProof(proof) || '- -' }}
                      </span>
                    </div>
                    <div class="pdf-item-text-wrapper text-right" style="width: 15%;">
                      <span class="pdf-item-text text-success font-weight-bold">
                        HK${{ formatMoney(proof.payment_amount || 0) }}
                      </span>
                    </div>
                    <div class="pdf-item-text-wrapper text-center" style="width: 30%;">
                      <span class="pdf-item-text text-primary">
                        {{ proof.payment_proof_number || '- -' }}.pdf
                      </span>
                    </div>
                  </div>
                </div>


                <div v-else class="text-center text-muted py-3">
                  <p class="mb-0">尚未上傳付款憑證</p>
                </div>
              </div>
            </div>
             <!-- 付款狀態總覽 -->
                <div class="pdf-form" style="min-height: 50px; margin-bottom: 20px;">
                  <b-row class="form-item align-items-center">
                  
                    <b-col cols="6"></b-col>
                    <b-col cols="6">
                      <b-row class="align-items-center">
                        <b-col cols="4" class="text-right title">帳單總額：</b-col>
                        <b-col cols="8" class="text">
                          <div class="form-value text-primary font-weight-bold">
                            HK${{ formatMoney(pdfData.bill_total_amount) }}
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="6"></b-col>
                    <b-col cols="6">
                      <b-row class="align-items-center">
                        <b-col cols="4" class="text-right title">付款總額：</b-col>
                        <b-col cols="8" class="text">
                          <div class="form-value text-success font-weight-bold">
                            HK${{ formatMoney(getTotalPaymentAmount()) }}
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="6" v-if="getTotalPaymentAmount() < pdfData.bill_total_amount"></b-col>
                    <b-col cols="6" v-if="getTotalPaymentAmount() < pdfData.bill_total_amount">
                      <b-row class="align-items-center">
                        <b-col cols="4" class="text-right title">未付總額：</b-col>
                        <b-col cols="8" class="text">
                          <div class="form-value text-danger font-weight-bold">
                            HK${{ formatMoney(pdfData.bill_total_amount - getTotalPaymentAmount()) }}
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
          </div>

          <!-- Footer & Company Info -->
          <div class="pdf-padding">
            <hr class="w-100" />
            <div class="d-flex company-info flex-wrap mb-0">
              <div class="w-50">
                <div class="d-flex">
                  <span>地址：</span>
                  <span>{{ info.address }}</span>
                </div>
              </div>
              <div class="w-50">
                <div class="d-flex">
                  <span>網址：</span>
                  <span>{{ info.website }}</span>
                </div>
              </div>
              <div class="w-50">
                <div class="d-flex">
                  <span>電話：</span>
                  <span>{{ info.phone }}</span>
                </div>
              </div>
              <div class="w-50">
                <div class="d-flex">
                  <span>電郵：</span>
                  <span>{{ info.email }}</span>
                </div>
              </div>
              <div class="w-50">
                <div class="d-flex">
                  <span>傳真：</span>
                  <span>{{ info.fax }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- 單據圖片區塊 -->
    <!-- 帳單單據 -->
    <b-row v-if="pdfData.image_url" class="pdf-add-row document-images-section document-page" style="margin-bottom: 0; padding-bottom: 0">
      <b-col class="pdf-add" cols="12" style="margin-bottom: 0; padding-bottom: 0">
        <b-card no-body class="pdf-preview-card document-full-page">
          <div class="document-page-content">
            <div class="document-title-section">
              <h2 class="document-page-title">帳單單據</h2>
            </div>
            <div class="watermark">
              {{ pdfData.bill_number || pdfData.id }}
            </div>
            <div class="document-image-wrapper">
              <div class="document-image-container">
                <img
                  :src="pdfData.image_url"
                  alt="帳單單據"
                  class="document-image"
                  :title="'帳單單據 - ' + (pdfData.bill_number || pdfData.id)"
                />
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- 付款憑證單據 -->
    <template v-if="pdfData.payment_proofs && pdfData.payment_proofs.length > 0">
      <b-row
        v-for="(proof, index) in pdfData.payment_proofs"
        :key="index"
        class="pdf-add-row document-images-section document-page"
        style="margin-bottom: 0; padding-bottom: 0"
      >
        <b-col class="pdf-add" cols="12" style="margin-bottom: 0; padding-bottom: 0">
          <b-card no-body class="pdf-preview-card document-full-page">
            <div class="document-page-content">
              <div class="document-title-section">
                <h2 class="document-page-title">
                  付款憑證單據 {{ pdfData.payment_proofs.length > 1 ? `(${index + 1}/${pdfData.payment_proofs.length})` : '' }}
                </h2>
              </div>
              <div class="watermark">
                {{ proof.payment_proof_number || '付款憑證' }}
              </div>
              <div class="document-image-wrapper">
                <div class="document-image-container">
                  <img
                    :src="proof.payment_proof_url"
                    alt="付款憑證單據"
                    class="document-image"
                    :title="'付款憑證單據 - ' + (proof.payment_proof_number || '付款憑證')"
                  />
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </template>

    <!-- 付款收據單據 -->
    <b-row v-if="pdfData.payment_receipt_url" class="pdf-add-row document-images-section document-page" style="margin-bottom: 0; padding-bottom: 0">
      <b-col class="pdf-add" cols="12" style="margin-bottom: 0; padding-bottom: 0">
        <b-card no-body class="pdf-preview-card document-full-page">
          <div class="document-page-content">
            <div class="document-title-section">
              <h2 class="document-page-title">付款收據單據</h2>
            </div>
            <div class="watermark">
              {{ pdfData.receipt_number || '付款收據' }}
            </div>
            <div class="document-image-wrapper">
              <div class="document-image-container">
                <img
                  :src="pdfData.payment_receipt_url"
                  alt="付款收據單據"
                  class="document-image"
                  :title="'付款收據單據 - ' + (pdfData.receipt_number || '付款收據')"
                />
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText } from "bootstrap-vue";
import { mapFields } from "vuex-map-fields";
import { ref, watch } from "@vue/composition-api";
import { formatMoney } from "@/libs/helper.js";

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {
    formatMoney,
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-TW');
    },
    getPaymentStatus() {
      const hasPaymentReceipt = this.pdfData.payment_receipt_path || this.pdfData.payment_receipt_url;
      const hasPaymentProofs = this.hasPaymentProofs();
      const totalPaymentAmount = this.getTotalPaymentAmount();
      const billTotalAmount = Number(this.pdfData.bill_total_amount) || 0;

      if (hasPaymentReceipt) {
        return {
          text: '已完成付款',
          class: 'text-success'
        };
      } else if (hasPaymentProofs && totalPaymentAmount >= billTotalAmount) {
        return {
          text: '埋數（待收據）',
          class: 'text-info'
        };
      } else if (hasPaymentProofs && totalPaymentAmount < billTotalAmount) {
        return {
          text: '未埋數',
          class: 'text-warning'
        };
      } else {
        return {
          text: '未付款',
          class: 'text-danger'
        };
      }
    },
    hasPaymentProofs() {
      // 只檢查新版多筆付款憑證
      return this.pdfData.payment_proofs && this.pdfData.payment_proofs.length > 0;
    },
    getTotalPaymentAmount() {
      // 只計算新版多筆付款憑證總額
      if (this.pdfData.payment_proofs && this.pdfData.payment_proofs.length > 0) {
        return this.pdfData.payment_proofs.reduce((sum, proof) => {
          return sum + (Number(proof.payment_amount) || 0);
        }, 0);
      }
      return 0;
    },
    getPaymentMethodNameForProof(proof) {
      if (!proof.payment_method_id || !this.paymentMethodOptions) {
        return '-';
      }

      const method = this.paymentMethodOptions.find(m => m.id === proof.payment_method_id);
      let methodName = method ? method.name : '-';

      // 如果是支票付款且有支票號碼，顯示支票號碼
      if (proof.payment_method_id === 1 && proof.check_number) {
        methodName += ` (${proof.check_number})`;
      }

      return methodName;
    },
    getPaymentMethodName() {
      if (!this.pdfData.payment_method_id || !this.paymentMethodOptions) {
        return '-';
      }

      const method = this.paymentMethodOptions.find(m => m.id === this.pdfData.payment_method_id);
      let methodName = method ? method.name : '-';

      // 如果是支票付款且有支票號碼，顯示支票號碼
      if (this.pdfData.payment_method_id === 1 && this.pdfData.check_number) {
        methodName += ` (${this.pdfData.check_number})`;
      }

      return methodName;
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
    paymentMethodOptions: {
      type: Array,
      required: true,
    },
  },

  mounted() {
    // 組件掛載後的邏輯
  },
  computed: {
    ...mapFields(["controlValue"]),
  },
  setup(props) {
    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
      company_info: null,
      logo_url: null,
    });

    const getInfo = (template_id, stamp_id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.find((ele) => ele.id == template_id);

      let stamp =
        props.stampOptions &&
        props.stampOptions.find((ele) => ele.id == stamp_id);

      if (template) {
        info.value.website = template.website || '';
        info.value.address = template.address || '';
        info.value.phone = template.phone || '';
        info.value.fax = template.fax || '';
        info.value.email = template.email || '';
        info.value.company_info = template.company_info || '';
        info.value.bank_info = template.bank_info || '';
        info.value.logo_url = template.logo_url || '';
        info.value.stamp_url = stamp ? stamp.image_url || '' : '';
      }
    };

    // 監聽 pdfData 變化
    watch(
      () => props.pdfData,
      (newVal) => {
        if (newVal && newVal.template_id) {
          getInfo(newVal.template_id, newVal.stamp_id);
        } else {
          // 使用預設模板（第一個模板）
          if (props.templateOptions && props.templateOptions.length > 0) {
            getInfo(props.templateOptions[0].id, props.stampOptions && props.stampOptions.length > 0 ? props.stampOptions[0].id : null);
          }
        }
      },
      { immediate: true }
    );

    // 監聽 templateOptions 變化
    watch(
      () => props.templateOptions,
      (newVal) => {
        if (newVal && newVal.length > 0) {
          const templateId = props.pdfData && props.pdfData.template_id ? props.pdfData.template_id : newVal[0].id;
          const stampId = props.pdfData && props.pdfData.stamp_id ? props.pdfData.stamp_id : (props.stampOptions && props.stampOptions.length > 0 ? props.stampOptions[0].id : null);
          getInfo(templateId, stampId);
        }
      },
      { immediate: true }
    );

    return {
      info,
      getInfo
    };
  },
};
</script>

<style lang="scss" scoped>
// PDF 基本樣式

.pdf-add-wrapper .pdf_header{
  height:270px!important;
}

.pdf-add-wrapper {
  .pdf-preview-card {
    box-shadow: none;
    border: none;
    height:1090px;
  }


  // .pdf_header {
  //   .logo {
  //     text-align: center;
  //     margin-bottom: 20px;

  //     img {
  //       max-height: 80px;
  //       width: auto;
  //     }

  //     h2 {
  //       color: #333;
  //       font-weight: bold;
  //       margin-top: 10px;
  //     }
  //   }

  //   .license {
  //     text-align: center;
  //     margin-bottom: 20px;z     
  //     font-size: 14px;
  //     color: #666;
  //   }
  // }
  .pdf-form {
    .form-item {
      margin-bottom: 15px;

      .title {
        font-weight: bold;
        color: #333;
        padding-right: 10px;
      }

      .form-value {
        padding: 5px 10px;
        border-bottom: 1px solid #000;
        min-height: 25px;

        &.pdf-number {
          font-weight: bold;
        }
      }
    }
  }
}

// 區塊標題樣式
.pdf-section-title {
  text-align: center;
  margin: 30px 0 10px;

  h4 {
    color: #333;
    font-weight: bold;
    border-bottom: 2px solid #007bff;
    padding-bottom: 10px;
    display: inline-block;
  }
}
.pdf-add-wrapper .pdf-table{
    min-height: 6cm;
}

// 表格樣式
.pdf-table {
  border: 1px solid #333;
  margin-bottom: 20px;


  &.bill-items {
    .table-header {
      background-color: #f8f9fa;
      border-bottom: 2px solid #333;

      .thead-label {
        padding: 10px;
        font-weight: bold;
        text-align: center;
        // border-right: 1px solid #333;

        &:nth-child(1) { width: 30%; } // 發票編號
        &:nth-child(2) { width: 50%; } // 帳單備註
        &:nth-child(3) { width: 20%; } // 金額

        &:last-child {
          border-right: none;
        }
      }
    }

    .pdf-item {
      border-bottom: 1px solid #000;

    

      .pdf-item-text-wrapper {
        padding: 8px 10px;
        // border-right: 1px solid #000;

        &:nth-child(1) { width: 30%; } // 發票編號
        &:nth-child(2) { width: 50%; } // 帳單備註
        &:nth-child(3) { width: 20%; } // 金額

        &:last-child {
          border-right: none;
        }

        .pdf-item-text {
          font-size: 14px;
          line-height: 1.4;
        }
      }
    }
  }
}

// 單據圖片區塊樣式
.document-images-section {
  page-break-before: always;

  &.document-page {
    // min-height: 100vh;
    // height: 100vh;

    .watermark {
      // position: absolute;
      // bottom: 15px;
      // right: 15px;
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 8px 15px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: bold;
      z-index: 10;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        margin-bottom: 40px;
    }
    .document-full-page {
      // height: calc(100vh - 23px);
      display: flex;
      flex-direction: column;

      .document-page-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 40px 20px;

        .document-title-section {
          flex-shrink: 0;
          margin-bottom: 40px;
          text-align: center;

          .document-page-title {
            color: #333;
            font-weight: bold;
            font-size: 20px;
            margin: 0;
            padding: 15px 30px;
            border-bottom: 2px solid #007bff;
            display: inline-block;
          }
        }

        .document-image-wrapper {
          flex: 1;
          display: flex;
          justify-content: center;
          width: 100%;
          max-width: 100%;
          // border:1px solid #ededed;

          .document-image-container {
            position: relative;
            text-align: center;
            max-width: 90%;
            max-height: 70vh;

            .document-image {
              max-width: 100%;
              max-height: 90vh;
              width: auto;
              height: auto;
              object-fit: contain;
            }

          }
        }
      }
    }
  }

  // 保留舊樣式以防向後兼容
  .document-section {
    margin-bottom: 30px;
      .watermark {
        position: absolute;
        bottom: 10px;
        right: 10px;
        background-color: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
        z-index: 10;
      }

    .document-title {
      color: #333;
      font-weight: bold;
      margin-bottom: 15px;
      text-align: center;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;
    }

    .document-image-container {
      position: relative;
      text-align: center;
      margin-bottom: 20px;

      .document-image {
        max-width: 100%;
        max-height: 600px;
        width: auto;
        height: auto;
        border: 1px solid #ddd;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

    
    }
  }
}

// 公司資訊樣式
.company-info {
  font-size: 14px;
  color: #666;

  .d-flex {
    margin-bottom: 5px;

    span:first-child {
      font-weight: bold;
      margin-right: 5px;
    }
  }
}

// 顏色類別
.colorRed {
  color: #dc3545 !important;
}

.text-primary {
  color: #007bff !important;
}

.text-success {
  color: #28a745 !important;
}

.text-warning {
  color: #ffc107 !important;
}

.text-info {
  color: #17a2b8 !important;
}

// 字體粗細
.font-weight-bold {
  font-weight: bold !important;
}

// 內邊距
.pdf-padding {
  padding: 10px 20px 0;
}

// 響應式調整
@media print {
  .document-images-section {
    page-break-before: always;

    &.document-page {
      height: 100vh;
      min-height: 100vh;
      page-break-inside: avoid;
      page-break-after: always;

      .document-full-page {
        height: 100vh;

        .document-page-content {
          height: 100vh;

          .document-title-section {
            .document-page-title {
              font-size: 24px;
              padding: 12px 25px;
            }
          }

          .document-image-wrapper {
            .document-image-container {
              .document-image {
                max-height: 65vh;
              }
            }
          }
        }
      }
    }
  }

  .document-section {
    page-break-inside: avoid;
  }
}
</style>
